import React, { Component } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap'
import Projectname from './projectname.jsx'
import { RootCloseWrapper } from 'react-overlays'

import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/timer';
import { connect } from 'react-redux';
import {colorToHex} from '../api/color'

class CustomToggle extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    return (
      <div className="dropdown-btn" onClick={this.handleClick}>
        {this.props.children}
      </div>
    );
  }
}

class CustomMenu extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      value: ''
    };
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  render() {
    const { children } = this.props;
    const { value } = this.state;
    
    return (
      <div className="dropdown-menu">
        <input id="projectDdInput" ref={c => {this.input = c;}} type="text" placeholder="جستجو" onChange={this.handleChange} value={value || ''}/>
        <ul className="project-list">
          {React.Children.toArray(children).filter(
            child => !value.trim() || child.props.children.props.children.toLowerCase().indexOf(value.toLowerCase()) !== -1
          )}
        </ul>
      </div>
    );
  }
}

class Project extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false,
      project : {name:'', color:0}
    };
    this.toggleOpenState = () => this.setState({open : !this.state.open})
    this.setOpenStateToFalse = ()=> {
      if(!this.state.open){
        document.getElementById("projectDdInput").focus();
      }
      this.setState({open : false});
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(p) {
    this.props.selectRecordProject(p, this.props.selected)
    this.toggleOpenState()
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.selected)this.setState({project:nextProps.selected.project})
  }

  componentWillMount(){
    this.setState({project: this.props.selected.project})
  }

  render() {
    // filter projects that are not active :
    let projects = this.props.app.work_space.projects.filter(project => project.is_active);

    const projectList = projects.map((p) => (
      <MenuItem eventKey={p.id} key={p.id} onClick={() => {this.handleClick(p)} } >
        <Projectname color={ colorToHex(p.color) }>{p.name}</Projectname>
      </MenuItem>
    ));
    return (
      
      <div className="project-col">
        <RootCloseWrapper onRootClose={this.setOpenStateToFalse}>
          <Dropdown open={this.state.open} onToggle={this.toggleOpenState} id="dropdown-custom-menu">
            <CustomToggle bsRole="toggle">
              <Projectname color={(this.state.project.name) ? ( colorToHex(this.state.project.color) ) : (null) }>{ (this.state.project.name) ? (this.state.project.name) : ('بدون پروژه') }</Projectname>
            </CustomToggle>

            <CustomMenu bsRole="menu">
              {projectList}
            </CustomMenu>
          </Dropdown>
        </RootCloseWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

Project.defaultProps = {
  selected : {
    project : {
      color : ''
    }
  },
  selectRecordProject : () => {},
  active : false
}

export default connect(mapStateToProps, mapDispachToProps)(Project);
